/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SearchTeamMemberAvailabilityRequest} from '@cash-web/protos/squareup/timecards/scheduling/availability.pb'
import {SearchTeamMemberAvailabilityResponse} from '@cash-web/protos/squareup/timecards/scheduling/availability.pb'


export const searchTeamMemberAvailability = (request: SearchTeamMemberAvailabilityRequest, options?: CashRequestOptions) => post<SearchTeamMemberAvailabilityRequest, SearchTeamMemberAvailabilityResponse>("/2.0/cash/search-team-member-availability", request, {...options, rejectOnError: true })